/* Policy navigation and Shopify browser-level sale/sharing opt-out. */
(() => {
  'use strict';
  const button = document.getElementById('privacy-opt-out');
  const status = document.getElementById('privacy-status');
  if (!button || !status) return;
  let busy = false;
  let loading;
  const api = () => window.Shopify?.customerPrivacy;
  const usable = () => typeof api()?.currentVisitorConsent === 'function' && typeof api()?.setTrackingConsent === 'function';
  function loadPrivacy() {
    if (usable()) return Promise.resolve(api());
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const started = Date.now();
      let settled = false;
      const finish = (error) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        if (error || !usable()) reject(new Error('Privacy service unavailable'));
        else resolve(api());
      };
      const timer = setTimeout(() => finish(true), 10000);
      function attempt() {
        if (settled) return;
        if (usable()) return finish();
        if (window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], finish);
        } else if (!window.Shopify?.shop || Date.now() - started > 9500) finish(true);
        else setTimeout(attempt, 100);
      }
      attempt();
    }).finally(() => { loading = null; });
    return loading;
  }
  function saved() {
    return usable() && api().currentVisitorConsent().sale_of_data === 'no';
  }
  function render() {
    if (!usable()) return;
    const optedOut = saved();
    const gpcHonored = navigator.globalPrivacyControl === true && api().saleOfDataAllowed?.() === false;
    button.disabled = optedOut || gpcHonored;
    button.textContent = optedOut || gpcHonored ? 'Opt-out saved' : 'Do not sell or share my data';
    status.textContent = gpcHonored
      ? 'Your Global Privacy Control signal is being honored for this browser.'
      : optedOut ? 'Your opt-out is saved for this browser and device.'
      : 'You have not saved an opt-out for this browser. Select the button above to save your choice.';
    status.dataset.state = optedOut || gpcHonored ? 'saved' : 'ready';
  }
  function failed(message) {
    button.disabled = false;
    button.textContent = 'Try saving my opt-out again';
    status.textContent = message;
    status.dataset.state = 'error';
  }
  button.addEventListener('click', async () => {
    if (busy) return;
    busy = true;
    button.disabled = true;
    button.textContent = 'Saving your preference…';
    status.textContent = 'Please wait while your choice is saved.';
    try {
      const privacy = await loadPrivacy();
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Save timed out')), 10000);
        privacy.setTrackingConsent({sale_of_data:false}, () => {
          clearTimeout(timer);
          saved() ? resolve() : reject(new Error('Choice not confirmed'));
        });
      });
      render();
    } catch {
      if (saved()) render();
      else failed('We could not confirm your opt-out. Please try again, or contact us using the link below.');
    } finally {
      busy = false;
    }
  });
  document.addEventListener('visitorConsentCollected', () => { if (!busy) render(); });
  loadPrivacy().then(render).catch(() => {
    if (!window.Shopify?.shop) {
      button.disabled = true;
      button.textContent = 'Available on our online store';
      status.textContent = 'This local design preview cannot save a preference. Use this page on our online store to save your choice.';
    } else failed('Your privacy preference could not be loaded. Try again, or contact us using the link below.');
  });
})();
(() => {
  'use strict';
  if (!document.body.classList.contains('service-page')) return;
  const $ = selector => document.querySelector(selector);
  let quiet = new URLSearchParams(location.search).get('quiet') === '1';
  try { quiet ||= ['1','true'].includes(localStorage.getItem('paw-preview-quiet')); } catch {}
  document.body.dataset.quiet = String(quiet);
  function localLink(href) {
    const url = new URL(href,location.href);
    if (url.origin === location.origin && /^https?:$/.test(url.protocol) && quiet) url.searchParams.set('quiet','1');
    return url.href;
  }
  document.querySelectorAll('a[href]').forEach(a=>{if(!a.getAttribute('href').startsWith('#'))a.href=localLink(a.href);});
  const dialogs = [$('#search'),$('#menu')].filter(Boolean);
  const openers = new WeakMap();
  document.querySelectorAll('[data-dialog]').forEach(button=>button.addEventListener('click',()=>{
    const dialog=document.getElementById(button.dataset.dialog);if(!dialogs.includes(dialog))return;
    openers.set(dialog,button);dialog.showModal();if(dialog.id==='search')$('#search-field').focus();
  }));
  dialogs.forEach(dialog=>{
    dialog.querySelectorAll('[data-service-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
    dialog.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();dialog.close();}});
    dialog.addEventListener('close',()=>openers.get(dialog)?.focus({preventScroll:true}));
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
  });
  function reveal(hash, move=false) {
    let id;try{id=decodeURIComponent(hash.slice(1));}catch{return null;}
    const target=document.getElementById(id);if(!target || !target.closest('main'))return null;
    for(let el=target;el;el=el.parentElement){if(el.tagName==='DETAILS')el.open=true;}
    if(move)requestAnimationFrame(()=>{target.tabIndex=-1;target.focus({preventScroll:true});target.scrollIntoView({behavior:'auto',block:'start'});});
    return target;
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(!link)return;link.href=localLink(link.href);
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank')return;
    const url=new URL(link.href);if(url.origin!==location.origin||url.pathname!==location.pathname||!url.hash)return;
    const target=reveal(url.hash);if(!target)return;
    event.preventDefault();dialogs.forEach(d=>{if(d.open)d.close();});history.pushState(null,'',url);reveal(url.hash,true);
  },true);
  addEventListener('hashchange',()=>reveal(location.hash,true));
  if(location.hash)reveal(location.hash,true);
  const pages=[
    ['Privacy Policy','/pages/privacy-policy','privacy data photos personal'],
    ['Your photos and permission','/pages/privacy-policy#pch-photos','photos filming permission marketing'],
    ['Terms of Service','/pages/terms-of-service','terms legal cancellation license'],
    ['Your Privacy Choices','/pages/data-sharing-opt-out','privacy choices opt out sharing data'],
    ['Shipping & delivery','/pages/shipping-policy','shipping delivery cost fee worldwide tax customs'],
    ['Delivery timing','/pages/shipping-policy#timing','time arrive preview production weeks days'],
    ['Rush crafting','/pages/shipping-policy#rush','rush sooner urgent fee'],
    ['Tracking help','/pages/shipping-policy#lost-parcel','tracking stuck lost parcel'],
    ['Returns & remakes','/pages/custom-orders-reprint-policy','returns remake refund cancellation damaged incorrect'],
    ['Cancelling your order','/pages/custom-orders-reprint-policy#cancellations','cancel approval design preview no reply 3+3'],
    ['The Remake Promise','/pages/custom-orders-reprint-policy#remake-promise','damaged wrong incorrect remake photos'],
    ['Refund timing','/pages/custom-orders-reprint-policy#refund-timing','refund bank money payment'],
    ['Frequently asked questions','/pages/faq','faq care materials questions'],
    ['Get in touch','/pages/contact','contact email help order'],
    ['Shop all','/collections/all','products figurine keychain'],
    ['How it works','/pages/how-it-works','making process'],
    ['Photo guide','/pages/photo-guide','upload photo front side back'],
    ['Our studio','/pages/studio','real photos video painting'],
    ['Our story','/pages/about','about brand story']
  ];
  const normalize=v=>String(v||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  function search(){
    const words=normalize($('#search-field').value).split(' ').filter(Boolean);
    const matches=pages.filter(([name,,terms])=>words.every(word=>normalize(name+' '+terms).includes(word)));
    const container=$('#search-results');container.replaceChildren();
    if(!matches.length){const p=document.createElement('p');p.textContent='No matches yet. Try “shipping”, “refund” or “photos”.';container.append(p);}
    matches.forEach(([name,href])=>{const link=document.createElement('a');link.href=localLink(href);link.textContent=name+' ↗';container.append(link);});
  }
  if($('#search-field')){$('#search-field').addEventListener('input',search);search();}
  const jumps=$('#legal-jump');
  if(jumps)jumps.addEventListener('change',()=>{
    if(!jumps.value)return;
    const hash='#'+jumps.value;
    if(!reveal(hash))return;
    history.pushState(null,'',hash);reveal(hash,true);
  });
  const chapters=[...document.querySelectorAll('.legal-section,.legal-control')];
  const toc=[...document.querySelectorAll('.legal-toc a')];
  function highlight(){
    const active=chapters.filter(el=>el.getBoundingClientRect().top<180).at(-1)||chapters[0];
    toc.forEach(link=>{if(link.hash==='#'+active?.id)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
    if(jumps && document.activeElement!==jumps)jumps.value=active?.id||'';
  }
  let scheduled=false;
  addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{highlight();scheduled=false;});}},{passive:true});
  highlight();
})();
